import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import React, { useContext, useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import Create from "../../../assets/Icon/create.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import { io } from "socket.io-client";
import { useRef } from "react";
import { serverInfo } from "../../../App";
import useFileHandleS3 from "../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../MediaUploadProgressBar";
import useThumbnailHandleS3 from "../../../CustomHooks/useThumbnailHandleS3";
import useVideoHandleWithCompress from "../../../CustomHooks/useVideoHandleWithCompress";
const AddSessionForm = () => {
  const history = useHistory();
  const socket = useRef();
  const [errorList, setErrorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonActive, setButtonActive] = useState(false);
  const [descriptionErrorResult, setDescriptionErrorResult] = useState("");
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  // Editor Funtionalities //
  const [convertedContent, setConvertedContent] = useState(null);

  // End Editor Functionalies //
  const [starList, setStarList] = useState([]);
  const [postType, setPostType] = useState("");
  // const [vWidth, setVWidth] = useState("");
  // const [vHeight, setVHeight] = useState("");
  const [paymentType, setPaymentType] = useState("");

  // File Handle
  const [file, setFile] = useState('');
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'post/images', delKey);


  // Video File Handle
  const [video, setVideo] = useState('');
  const [videoPath, setVideoPath] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight, videoWidth] = useVideoHandleWithCompress(video, 'post/videos', videoDelKey);
  const [isVideoReady, setIsVideoReady] = useState(true);

  // Thumbnail File Handle
  const [thumbnail, setThumbnail] = useState('');
  const [thumbnailDelKey, setThumbnailDelKey] = useState(null);
  const [thumbImageUrl,thumbImageKey,thumbProgress] = useThumbnailHandleS3(thumbnail, 'post/videos/thumbnail', thumbnailDelKey);

  const [registerInput, setRegister] = useState({
    title: "",
    description: "",
    star_id: "",
    fee: "",
    lat: "",
    lng: "",
    location: "",
    error_list: [],
  });

    const requiredText= {
        color: 'red',
        fontSize: '12px',
    };
  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  }, []);

  const handleChange = (file) => {
    setFile(file[0]);
    setDelKey(fileKey);
  };
  const handleChangeVideo = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
    setIsVideoReady(false);
  };

  const loadedVideo = (s) =>{
    // setVHeight(s.wrapper.firstChild.videoHeight);
    // setVWidth(s.wrapper.firstChild.videoWidth);
    setIsVideoReady(true)
  }
  const handleThumbnail = (file) => {
    setThumbnailDelKey(thumbImageKey);
    setThumbnail(file[0]);
  };

  function handleType(e) {
    setPostType(e.target.value);
  }
  function handleType2(e) {
    setPaymentType(e.target.value);
  }

  // added by rasel
const handleLocation = () => {
    console.log(navigator.geolocation.getCurrentPosition);
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(

            (position) => {
              setRegister({
                  ...registerInput,
                  location: `${position.coords.latitude},${position.coords.longitude}`,
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                });

                 // Reverse Geocode to get address
                //  try {
                //     axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`)
                //         .then((res) => {
                //             console.log(res.data.results[0].formatted_address);
                //         });
                // } catch (error) {
                //     console.error("Error getting location:", error);
                // }



            },
            (error) => {
                console.error("Error getting location:", error);
            }
        );
    } else {
        console.error("Geolocation is not supported by this browser.");
    }
};

  const registerSubmit = (e) => {
    e.preventDefault();
    if(convertedContent == "" || convertedContent == null ){
          setDescriptionErrorResult("Sorry, Description can not be empty.");
    }else {
        setDescriptionErrorResult("")
        setButtonActive(true);
        setLoading(true);
        const fData = new FormData();

        fData.append("image", fileKey);
        fData.append("video", videoKey);
        fData.append("thumbnail", thumbImageKey);
        fData.append("title", registerInput.title);
        fData.append("star_id", registerInput.star_id);
        fData.append("description", convertedContent);
        fData.append("fee", registerInput.fee);
        fData.append("type", paymentType);
        fData.append("post_type", postType);
        fData.append("v_width", videoWidth);
        fData.append("v_height", videoHeight);

        fData.append("location", registerInput.location);
        fData.append("lat", registerInput.lat);
        fData.append("lng", registerInput.lng);

        axios.get("/sanctum/csrf-cookie").then((response) => {
            axios.post(`/api/admin/add_simple_post`, fData).then((res) => {
                setLoading(false);
                setButtonActive(false);
                if (res.data.status === 402) {
                    setErrorList(res.data.errors);
                } else {
                    socket.current.emit("simple_post_approve", {
                        id: res.data.post.id,
                    });
                    history.push("/superstar-admin/post/pending");
                }
            });
        });
    }
  };

  return (
    <>
      <AllDataHeader title={"Create Post"} image={Create} count={"Zero"} />

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  className="p-3"
                  onSubmit={registerSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="form-group row d-flex justify-content-center my-4">
                    <label className="col-sm-3 label-text">Select Star</label>
                    <div className="col-sm-7">
                      <select
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={registerInput.star_id}
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList.map((star, index) => (
                          <option className="text-black" value={star.id}>
                            {star.first_name} {star.last_name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">{errorList.star_id}</span>
                    </div>
                  </div>

                  <div className="form-group row d-flex justify-content-center my-4">
                    <label className="col-sm-3 label-text ">Post Type</label>
                    <div className="col-sm-3">
                      <select
                        onChange={handleType}
                        className="form-control reply-control"
                      >
                        <option className="text-black" value="">
                          Select Post Type
                        </option>
                        <option className="text-black" value="general">
                          General
                        </option>
                        <option className="text-black" value="video">
                          Video
                        </option>
                      </select>
                      <span className="text-danger">{errorList.post_type}</span>
                    </div>

                    <label className="col-sm-1 label-text text-md-end text-lg-end  ">
                      Type
                    </label>

                    <div className="col-sm-3">
                      <select
                        onChange={handleType2}
                        name="type"
                        className="form-control reply-control"
                        value={paymentType}
                      >
                        <option className="text-black" value="">
                          Select Payment Type
                        </option>
                        <option className="text-black" value="free">
                          Free
                        </option>
                        <option className="text-black" value="paid">
                          Paid
                        </option>
                      </select>
                      <span className="text-danger">{errorList.type}</span>
                    </div>
                  </div>

                  <div className="form-group row d-flex justify-content-center my-4">
                    <label className="col-sm-3 label-text ">Title <span style={requiredText} > *</span></label>
                    <div className="col-sm-7">
                      <input
                        required
                        type="text"
                        className="form-control reply-control"
                        placeholder="Enter title here...!"
                        onChange={handleInput}
                        name="title"
                        value={registerInput.title}
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>


                  <div className="form-group row d-flex justify-content-center my-4">
                    <label className="col-sm-3 label-text ">Location </label>

                    <div className="col-sm-5">
                          <input
                            type="text"
                            className="form-control reply-control"
                            placeholder="Enter location here...!"
                            onChange={handleInput}
                            name="location"
                            value={registerInput.location}
                          />

                          <input type="hidden" name="lat" value={registerInput.lat} />
                          <input type="hidden" name="lng" value={registerInput.lng} />

                      </div>

                    <div className="col-sm-2">

                      <button className="btn fw-bold custom_location_btn" type="button" onClick={handleLocation}>
                          Get Location
                      </button>
                      
                    </div>

                  </div>


                  <div className="form-group row d-flex justify-content-center my-4">
                    <label className="col-sm-3 label-text ">Description <span style={requiredText} > *</span></label>
                    <div className="col-md-7">
                      <CKEditor
                        editor={ClassicEditor}
                        data={convertedContent}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                        {descriptionErrorResult !="" ? (
                            <span className="text-danger">
                            {descriptionErrorResult}
                            </span>):("")
                        }
                      <span className="text-danger">
                        {errorList.description}
                      </span>
                    </div>
                  </div>
                  {postType === "general" ? (
                    <div className="form-group row d-flex justify-content-center my-3">
                      <label className="col-sm-3 label-text ">Banner</label>
                      <div className="col-sm-7 file-x-i">
                        {fileUrl ? (
                          <img
                            src={fileUrl}
                            className="demo-preview-image img-fluid"
                            alt=""
                            style={{
                              height: "200px",
                              width: "600px",
                            }}
                          />
                        ) : (
                          ""
                        )}

                        <input
                          type="file"
                          accept="image/*"
                          className="form-control reply-control mb-3"
                          onChange={(e) => handleChange(e.target.files)}
                          id="image"
                          name="image"
                        />
                         {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}

                        <span className="text-danger">{errorList.image}</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {postType === "video" ? (
                    <>
                      <div className="form-group row d-flex justify-content-center my-3">
                        <label className="col-sm-3 label-text ">Video</label>
                        <div className="col-sm-7 file-x-i">
                          {videoUrl ? (
                            <ReactPlayer
                              onReady={(e)=>loadedVideo(e)}
                              url={videoUrl}
                              controls
                              playing={false}
                              volume={1}
                              width="100%"
                              height="200px" // style={{ margin: "0 auto" }}
                            />
                          ) : !isVideoReady ? <div
                                className="d-flex flex-column justify-content-center align-items-center"
                                style={{ width: "100%", height: "200px", backgroundColor: "#222", borderRadius: "10px" }}
                              >
                                <div className="spinner-border" style={{ color: "#fff" }} role="status" />
                                <div className="mt-2 text-white text-center">
                                  <div>Video is compressing...</div>
                                </div>
                              </div>
                             : null}
                          <input
                            type="file"
                            accept="video/*"
                            className="form-control reply-control mb-3"
                            onChange={(e) => handleChangeVideo(e.target.files)}
                            id="video"
                            name="video"
                          />
                          {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}                

                          <span className="text-danger">{errorList.video}</span>
                        </div>
                      </div>
                      <div className="form-group row d-flex justify-content-center my-3">
                        <label className="col-sm-3 label-text  ">
                          Thumbnail
                        </label>
                        <div className="col-sm-7 file-x-i">
                          {thumbImageUrl ? (
                            <img
                              src={thumbImageUrl}
                              className="demo-preview-image img-fluid"
                              alt=""
                              style={{ height: "200px", width: "400px" }}
                            />
                          ) : (
                            ""
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            className="form-control reply-control mb-3"
                            onChange={(e) => handleThumbnail(e.target.files)}
                            id="thumbnail"
                            name="thumbnail"
                          />
                       {thumbnail && !thumbImageUrl && <MediaUploadProgressBar progress={thumbProgress} />}

                          <span className="text-danger">
                            {errorList.thumbnail}
                          </span>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {paymentType === "paid" ? (
                    <div className="form-group row d-flex justify-content-center my-4">
                      <label className="col-sm-3 label-text ">Fees</label>
                      <div className="col-sm-7">
                        <input
                          type="number"
                          min={0}
                          className="form-control reply-control"
                          placeholder="Enter fee $"
                          onChange={handleInput}
                          name="fee"
                          value={registerInput.fee}
                        />
                        <span className="text-danger">{errorList.fee}</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit" disabled={buttonActive || !isVideoReady}>
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSessionForm;
